<template>
  <div class="joinVoteBox">
    <div class="joinVoteBoxIn">
      <!-- 头部 -->
      <div class="header">
        <h5>发起投票</h5>
        <i class="iconfont icon-guanbi" @click="closePop" />
      </div>
      <!-- secondTitle -->
      <div class="secondTitle">
        <p class="leftText">
          只可以选择已发布且在有效期内的投票，若投票未发布，请在
          <i class="voteManage" style="color: #2f96ff; cursor: pointer" @click="goVoting">
            投票管理
          </i>
          发布投票
        </p>
        <el-button class="newVote" @click="newAddVote">新建投票</el-button>
      </div>
      <!-- 表格 -->
      <div v-loading="loading" class="tableContent">
        <div class="header">
          <div class="item name">投票名称</div>
          <div class="item endTime">截止时间</div>
          <div class="item number">投票人数</div>
        </div>
        <div v-if="voteList.length" class="content" ref="labelFather" @click="labelClick">
          <label
            v-for="item in voteList"
            :key="item.vote_id"
            class="item"
            :class="testIncludesVoteId(item.vote_id) ? 'disabled' : ''"
          >
            <span class="radioContent">
              <input
                :id="item.vote_id"
                ref="inputRadio"
                class="radio"
                type="radio"
                name="vote"
                :disabled="testIncludesVoteId(item.vote_id)"
                :value="item.vote_id"
              />
              <i class="checked" />
            </span>
            <div class="itemIn name">{{ item.name }}</div>
            <div class="itemIn endTime">
              {{ new Date(Number(item.end_time * 1000)) | formatTime('YYYY-MM-DD') }}
            </div>
            <div class="itemIn number">{{ item.total_voter_num }}</div>
          </label>
        </div>
        <div v-else class="content noData">暂无有效投票</div>
      </div>
      <!-- 分页 -->
      <!-- v-if="Math.ceil(total / pageSize) > 1" -->
      <div class="release-page clearfix">
        <el-pagination
          class="release-pagination"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="total"
          @current-change="handleCurrentChange"
        />
      </div>
      <!-- 确定 -->
      <div class="bottomBox">
        <button class="confirm" @click="confirmButton">确定</button>
      </div>
    </div>
  </div>
</template>
<script>
import { GetVoteListApi } from '@/api/releaseManagement';
export default {
  name: 'RecordPop',
  props: {
    recordId: {
      type: String,
      default: null,
    },
    listIds: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isShow: false,
      recordData: {},
      publicRecordUpLoding: [] /* 公众号发布中 */,
      publicRecordUpLoded: [] /* 公众号发布完成 */,
      pageIndex: 1 /* 页码 */,
      pageSize: 20 /* 每页显示数目 */,
      total: 0 /* 总条数 */,
      voteList: [] /* 投票列表 */,
      loading: true /* 是否加载中。。。 */,
    };
  },
  mounted() {
    /* 分页查询投票列表 */
    this.getVoteList();
  },
  methods: {
    labelClick() {
      // 获取label 委托
      const content = this.$refs.labelFather;
      for (let i = 0; i < content.childNodes.length; i++) {
        // 每个label
        const item = content.childNodes[i];
        for (let j = 0; j < item.childNodes.length; j++) {
          // 当前label下的input如果是选中状态, label添加active状态
          if (item.childNodes[0].childNodes[0].checked) {
            item.classList.add('active');
          } else {
            item.classList.remove('active');
          }
        }
      }
    },
    // 关闭当前组件
    closePop() {
      this.$emit('closeVote');
    },
    // 切换分页
    handleCurrentChange(e) {
      this.pageIndex = e;
      this.getVoteList();
    },
    /* 分页查询投票列表 */
    async getVoteList() {
      this.loading = true;
      try {
        const result = await GetVoteListApi({
          page_index: this.pageIndex,
          page_size: this.pageSize,
          status: '2',
        });
        this.total = result.total;
        this.voteList = result.vote_list;
      } catch {
        this.$message('获取投票列表失败');
      }
      this.loading = false;
    },
    // 确定按钮
    confirmButton() {
      const list = this.$refs.inputRadio;
      let checkedId = '';
      if (list) {
        checkedId = list.filter((item) => item.checked)[0]?.id;
      }
      // 有列表没选就提示
      if (list && !checkedId) {
        this.$message('请选择投票');
        return;
      }
      this.$emit('upSelectedVoteId', checkedId);
    },
    // 跳转到投票管理
    goVoting() {
      this.$router.push({
        name: 'voteManagement',
      });
    },
    // 新建投票
    newAddVote() {
      this.$emit('newVoteId');
    },
    /* 判断之前是否选择某个投票设置不能操作 */
    testIncludesVoteId(id) {
      return this.listIds.includes(id);
    },
  },
};
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
